import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AtSnackbarService, ERROR_DICTIONARY, ErrorDictionary } from '@anothertrip/anothertrip-ds';
import { catchError, throwError } from 'rxjs';

import { ErrorType } from '../../enums/error-type.enum';
import { InstagramService } from '../../services/instagram.service';
import { UserService } from '../../services/user/user.service';

export const instagramInterceptor: HttpInterceptorFn = (req, next) => {
  const instagramService = inject(InstagramService);
  const userService = inject(UserService);
  const snackbar = inject(AtSnackbarService);
  const dictionary = inject<ErrorDictionary>(ERROR_DICTIONARY);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.error?.errorType === ErrorType.InstagramTokenInvalid) {
        instagramService.clearConnection();
        userService.updateUser({
          instagramHandle: undefined,
          instagramUserId: undefined,
        });
        snackbar.show(dictionary.instagram.tokenInvalid, 'error', {
          duration: 5000,
        });
      }

      return throwError(() => error);
    })
  );
};
